import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/down.png'
import _imports_1 from '../../assets/performance/banner_cfm_1.png'
import _imports_2 from '../../assets/performance/footer.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-a7be5cbe")

_pushScopeId("data-v-a7be5cbe")
const _hoisted_1 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_2 = { class: "testMain" }
const _hoisted_3 = { class: "fitter_title" }
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("发送报告")
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_9 = { class: "dialogTitle" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("手动生成报告-按任务")
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "el-icon-message-solid" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("允许对比")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("生成报告")
const _hoisted_14 = { class: "dialogTitle" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, "手动生成报告", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("生成报告")
const _hoisted_17 = {
  key: 0,
  class: "editRecipient"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_21 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_23 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_25 = /*#__PURE__*/_createVNode("span", null, "发送报告", -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_27 = {
  class: "versionGeneration versionGeneration2",
  style: {}
}
const _hoisted_28 = { class: "copyVal" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("复制数据")
const _hoisted_30 = { id: "perf_report" }
const _hoisted_31 = {
  key: 0,
  class: "spacName"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("img", {
  class: "banner",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_33 = { class: "mainContent" }
const _hoisted_34 = { class: "spacName" }
const _hoisted_35 = { class: "gameTable" }
const _hoisted_36 = {
  rowspan: 3,
  class: "gameIcon"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("td", {
  colspan: 3,
  class: "game_name"
}, "【CFM场景dc采集】", -1)
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 安卓/iOS版本: ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" 测试时间: ")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 基线版本: ")
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" 风险等级: ")
const _hoisted_42 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" 测试类型: "),
  /*#__PURE__*/_createVNode("span", null, "地图DC性能测试")
], -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" 测试版本: ")
const _hoisted_44 = { class: "corePerformance" }
const _hoisted_45 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle bold" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("一、测试结论")
], -1)
const _hoisted_46 = { class: "spacName" }
const _hoisted_47 = /*#__PURE__*/_createVNode("li", {
  style: {"list-style":"none"},
  class: "bold"
}, "1.DC变化结论", -1)
const _hoisted_48 = { style: {"font-style":"italic","color":"#c8d2e2","list-style":"none"} }
const _hoisted_49 = { class: "corePerformance" }
const _hoisted_50 = { class: "spacName" }
const _hoisted_51 = /*#__PURE__*/_createVNode("p", { class: "bold" }, "2.DC性能", -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle bold" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("二、核心指标趋势图 ")
], -1)
const _hoisted_53 = { class: "spacName" }
const _hoisted_54 = /*#__PURE__*/_createVNode("span", { class: "labelStyle" }, "DC趋势图", -1)
const _hoisted_55 = { class: "labelStyle2" }
const _hoisted_56 = { class: "detailedTest" }
const _hoisted_57 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle bold" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("三、变化详情")
], -1)
const _hoisted_58 = { class: "spacName" }
const _hoisted_59 = /*#__PURE__*/_createVNode("p", { class: "bold" }, "top图:", -1)
const _hoisted_60 = { class: "bold" }
const _hoisted_61 = {
  key: 0,
  class: "gameTable5"
}
const _hoisted_62 = { style: {"width":"350px"} }
const _hoisted_63 = { style: {"width":"350px"} }
const _hoisted_64 = /*#__PURE__*/_createVNode("td", { style: {"width":"120px"} }, null, -1)
const _hoisted_65 = { class: "spacName" }
const _hoisted_66 = /*#__PURE__*/_createVNode("p", { class: "bold" }, "新图:", -1)
const _hoisted_67 = { class: "bold" }
const _hoisted_68 = {
  key: 0,
  class: "gameTable5"
}
const _hoisted_69 = { style: {"width":"350px"} }
const _hoisted_70 = { style: {"width":"350px"} }
const _hoisted_71 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_72 = { class: "detailedTest" }
const _hoisted_73 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle bold" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("四、详细数据")
], -1)
const _hoisted_74 = { class: "spacName" }
const _hoisted_75 = { class: "bold" }
const _hoisted_76 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_77 = { class: "gameTable5" }
const _hoisted_78 = { class: "gallery__big_box" }
const _hoisted_79 = {
  ref: "mask",
  class: "gallery__big_wrap"
}
const _hoisted_80 = /*#__PURE__*/_createVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode("div", _hoisted_3, [
                    _createVNode(_component_el_form, {
                      inline: true,
                      size: "mini",
                      class: "spacForm queryReport"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "报告名称" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.name_search,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name_search = $event)),
                              placeholder: "请选择",
                              onChange: _ctx.change_name_search
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.nameList, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.cur_version,
                                    label: item.cur_version,
                                    value: item.cur_version
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_dialog, {
                              modelValue: _ctx.dialogFormVisible1,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogFormVisible1 = $event))
                            }, {
                              footer: _withId(() => [
                                _createVNode("span", _hoisted_4, [
                                  _createVNode(_component_el_button, {
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogFormVisible1 = false))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_5
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _ctx.dialogFormVisible2
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_6
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ])
                              ]),
                              default: _withId(() => [
                                _withDirectives(_createVNode(_component_el_form, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_form_item, {
                                      class: "reportName",
                                      label: "报告名称",
                                      "label-width": _ctx.formLabelWidth
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          class: "report-input",
                                          modelValue: _ctx.form1.name,
                                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form1.name = $event)),
                                          autocomplete: "off",
                                          width: "500"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["label-width"])
                                  ]),
                                  _: 1
                                }, 512), [
                                  [_vShow, _ctx.dialogFormVisible1]
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.sendOut,
                              class: "down_img"
                            }, {
                              default: _withId(() => [
                                _hoisted_7,
                                _hoisted_8
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.dialogFormVisibleByTask,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogFormVisibleByTask = $event)),
                    width: "790px"
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_9, [
                        _createVNode("span", null, [
                          _hoisted_10,
                          _createVNode(_component_el_tooltip, {
                            class: "item",
                            effect: "dark",
                            content: "如只选择测试任务, 则按照任务完成自动生成报告的逻辑生成一份报告",
                            placement: "top"
                          }, {
                            default: _withId(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    footer: _withId(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.generateReportByTask,
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        model: _ctx.generateReportVersion,
                        "label-position": "top",
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "对比任务" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.oldEdition,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.generateReportVersion.oldEdition = $event)),
                                id: "old_version",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.RecentTaskrecord, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "测试任务" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.newEdition,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.generateReportVersion.newEdition = $event)),
                                id: "new_version",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.RecentTaskrecord, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "是否对比版本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_checkbox, {
                                modelValue: _ctx.contrast,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.contrast = $event))
                              }, {
                                default: _withId(() => [
                                  _hoisted_12
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.dialogFormVisible,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.dialogFormVisible = $event)),
                    width: "790px"
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    footer: _withId(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.generateReport,
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _hoisted_16
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        model: _ctx.generateReportVersion,
                        "label-position": "top",
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "旧版本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.oldEdition,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.generateReportVersion.oldEdition = $event)),
                                id: "old_version",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "新版本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.newEdition,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.generateReportVersion.newEdition = $event)),
                                id: "new_version",
                                placeholder: "请选择",
                                onChange: _ctx.selectVersion
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createVNode(_component_el_form_item, { label: "场景" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.scenetion,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.generateReportVersion.scenetion = $event)),
                                multiple: "",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_scene_version, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.scene_id_id,
                                      label: item.scene_id__chinese,
                                      value: item.scene_id_id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.localProject != 34 && _ctx.localProject != 40]
                          ])
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.edit)
                    ? (_openBlock(), _createBlock("div", _hoisted_17, [
                        _createVNode(_component_el_form, {
                          "label-position": "left",
                          "label-width": "100px",
                          model: _ctx.formMail,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "邮件标题" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.title,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formMail.title = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件发件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _createTextVNode(" 指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人" + _toDisplayString(_ctx.formMail.Sender), 1)
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.Sender,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.formMail.Sender = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件收件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _hoisted_18,
                                    _hoisted_19,
                                    _hoisted_20,
                                    _hoisted_21,
                                    _hoisted_22,
                                    _hoisted_23,
                                    _hoisted_24
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.addressee,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.formMail.addressee = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件抄送人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.CC_List,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.formMail.CC_List = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认发送报告吗？",
                              onConfirm: _cache[17] || (_cache[17] = ($event: any) => (_ctx.save_report(false))),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  disabled: _ctx.get_is_super,
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_25
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "info",
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.edit = false))
                            }, {
                              default: _withId(() => [
                                _hoisted_26
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_27, [
                    _createVNode("div", _hoisted_28, [
                      (
                    !_ctx.get_is_super &&
                    (_ctx.localProject === 34 ||
                      _ctx.localProject === 12 ||
                      _ctx.localProject === 47 ||
                      _ctx.localProject === 32 ||
                      _ctx.localProject === 35 ||
                      _ctx.localProject === 9 ||
                      _ctx.localProject === 36 ||
                      _ctx.localProject === 40)
                  )
                        ? (_openBlock(), _createBlock(_component_el_form, {
                            key: 0,
                            inline: true,
                            model: _ctx.copyVal,
                            size: "mini"
                          }, {
                            default: _withId(() => [
                              (_ctx.new_report.task_record_id != null)
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 0,
                                    label: "当前记录id:",
                                    class: "iTemWidth2"
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.new_report.task_record_id), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_form_item, {
                                label: "任务记录id",
                                class: "iTemWidth"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    onChange: _ctx.equipmentUpdate,
                                    modelValue: _ctx.copyVal.taskRecordId,
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.copyVal.taskRecordId = $event)),
                                    placeholder: "请选择任务记录id",
                                    filterable: ""
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.TaskRecordQuery, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.id,
                                          label: item.id,
                                          value: item.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                label: "设备数据",
                                class: "iTemWidth"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.copyVal.deviceVal,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.copyVal.deviceVal = $event)),
                                    placeholder: "请选择设备数据",
                                    filterable: ""
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.TaskRecordDevices, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.id,
                                          label: item.model.model,
                                          value: item.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_popconfirm, {
                                    title: "确认复制数据吗？",
                                    onConfirm: _ctx.CopyBtn,
                                    placement: "top"
                                  }, {
                                    reference: _withId(() => [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        disabled: _ctx.interfaceDisabled
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_29
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["onConfirm"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["model"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_30, [
                    (
                  _ctx.localProject !== 34 &&
                  _ctx.localProject !== 40 &&
                  _ctx.localProject !== 47
                )
                      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_31, [
                          _hoisted_32
                        ], 512)), [
                          [_directive_loading, _ctx.loading]
                        ])
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_33, [
                      _createVNode("div", _hoisted_34, [
                        _withDirectives(_createVNode("table", _hoisted_35, [
                          _createVNode("tr", null, [
                            _createVNode("td", _hoisted_36, [
                              _createVNode("img", {
                                src: _ctx.dcData.base?.project_icon
                              }, null, 8, ["src"])
                            ]),
                            _hoisted_37
                          ]),
                          _createVNode("tr", null, [
                            _createVNode("td", null, [
                              _hoisted_38,
                              _createVNode("span", null, _toDisplayString(_ctx.chDate0date(_ctx.dcData.base?.test_time)), 1)
                            ]),
                            _createVNode("td", null, [
                              _hoisted_39,
                              _createVNode("span", null, _toDisplayString(_ctx.dcData.base?.test_time), 1)
                            ]),
                            _createVNode("td", null, [
                              _hoisted_40,
                              _createVNode("span", null, _toDisplayString(_ctx.dcData.base?.base_version), 1)
                            ])
                          ]),
                          _createVNode("tr", null, [
                            _createVNode("td", null, [
                              _hoisted_41,
                              _createVNode("span", {
                                class: 
                            _ctx.dcData.risk === '高风险'
                              ? 'com_risk_red'
                              : 'com_risk_green'
                          
                              }, _toDisplayString(_ctx.dcData.risk), 3)
                            ]),
                            _hoisted_42,
                            _createVNode("td", null, [
                              _hoisted_43,
                              _createVNode("span", null, _toDisplayString(_ctx.dcData.base?.cur_version), 1)
                            ])
                          ])
                        ], 512), [
                          [_directive_loading, _ctx.loading]
                        ])
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createVNode("div", _hoisted_46, [
                          _hoisted_47,
                          _createVNode("li", _hoisted_48, _toDisplayString(_ctx.textDc), 1),
                          _createVNode(_component_el_table, {
                            data: _ctx.dc_change_list,
                            key: _ctx.setting,
                            "span-method": _ctx.cellMerge
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, {
                                prop: "scene",
                                label: "测试内容"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", null, _toDisplayString(scope.row?.test_content), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "scene",
                                label: "测试场景"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", null, _toDisplayString(scope.row?.scene), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                label: 
                          'DC性能趋势（' +
                          _ctx.dcData.base?.cur_version +
                          '对比' +
                          _ctx.dcData.base?.base_version +
                          '）'
                        
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_table_column, { label: "单局DC_MAX\nSUM(right:left:up:down)" }, {
                                    default: _withId((scope) => [
                                      _createVNode("div", null, [
                                        _createVNode("span", null, _toDisplayString(scope.row.sum), 1),
                                        _createVNode("span", null, _toDisplayString("(" +
                                scope.row.right +
                                "," +
                                scope.row.left +
                                "," +
                                scope.row.up +
                                "," +
                                scope.row.down +
                                ")"), 1)
                                      ]),
                                      _createVNode("div", null, _toDisplayString(scope.row.point), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, { label: "DC_MAX变化差值\nSUM(right:left:up:down)" }, {
                                    default: _withId((scope) => [
                                      _createVNode("div", null, [
                                        _createVNode("span", {
                                          class: scope.row.risk == '高风险' ? _ctx.bold : ''
                                        }, _toDisplayString(scope.row.sum_change), 3),
                                        _createVNode("span", null, _toDisplayString("(" +
                                scope.row.right_change +
                                "," +
                                scope.row.left_change +
                                "," +
                                scope.row.up_change +
                                "," +
                                scope.row.down_change +
                                ")"), 1)
                                      ]),
                                      _createVNode("div", null, _toDisplayString(scope.row.old_point), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_table_column, { label: "趋势风险" }, {
                                default: _withId((scope) => [
                                  _createVNode("span", {
                                    style: 'color:' + _ctx.colorRisk(scope.row.risk)
                                  }, _toDisplayString(scope.row.risk), 5)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["data", "span-method"])
                        ])
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_49, [
                        _createVNode("div", _hoisted_50, [
                          _hoisted_51,
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.Dc_Performance, (item) => {
                            return (_openBlock(), _createBlock(_component_el_card, {
                              key: item,
                              style: {"margin-bottom":"30px"}
                            }, {
                              default: _withId(() => [
                                _createVNode("div", {
                                  style: {"width":"100%","height":"350px"},
                                  id: 'performance' + item.value
                                }, null, 8, ["id"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ])
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ]),
                      _createVNode("div", null, [
                        _hoisted_52,
                        _createVNode("div", _hoisted_53, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.Core_indicators, (item) => {
                            return (_openBlock(), _createBlock(_component_el_card, {
                              style: {"margin-bottom":"30px"},
                              key: item
                            }, {
                              default: _withId(() => [
                                _createVNode("p", null, [
                                  _hoisted_54,
                                  _createVNode("span", _hoisted_55, "     场景：" + _toDisplayString(item), 1)
                                ]),
                                _createVNode("div", {
                                  id: 'performance_line' + item,
                                  style: {"width":"100%","height":"350px"}
                                }, null, 8, ["id"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ])
                      ]),
                      _createVNode("div", _hoisted_56, [
                        _hoisted_57,
                        _createVNode("div", _hoisted_58, [
                          _hoisted_59,
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dcData?.dc_change_detail_top, (k, v, i) => {
                            return (_openBlock(), _createBlock("div", { key: i }, [
                              _createVNode("p", _hoisted_60, _toDisplayString(i + 1) + "、" + _toDisplayString(v) + ":共" + _toDisplayString(k.count) + "个点有DC变化 ", 1),
                              (
                          _ctx.dcData?.dc_change_detail_top[v]?.dc_list?.length > 0
                        )
                                ? (_openBlock(), _createBlock("table", _hoisted_61, [
                                    _createVNode("thead", null, [
                                      _createVNode("tr", null, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pgc_detail, (item) => {
                                          return (_openBlock(), _createBlock("td", { key: item }, _toDisplayString(item), 1))
                                        }), 128))
                                      ])
                                    ]),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(k?.dc_list, (item, i) => {
                                      return (_openBlock(), _createBlock("tr", { key: i }, [
                                        _createVNode("td", null, _toDisplayString(i + 1), 1),
                                        _createVNode("td", null, [
                                          _createVNode("div", null, _toDisplayString(item.key[2][1]), 1),
                                          _createVNode("div", null, _toDisplayString("(" +
                                item.key[0] +
                                "," +
                                item.key[1] +
                                "," +
                                item.key[2][0] +
                                ")"), 1)
                                        ]),
                                        _createVNode("td", null, [
                                          _createVNode("div", null, _toDisplayString(_ctx.diff(item.diff)), 1),
                                          _createVNode("div", null, "new:" + _toDisplayString(item.new), 1),
                                          _createVNode("div", null, "old:" + _toDisplayString(item.old), 1)
                                        ]),
                                        _createVNode("td", _hoisted_62, [
                                          _createVNode("img", {
                                            style: {"max-width":"350px"},
                                            onClick: ($event: any) => (_ctx.imgBtn(item.new_image_path)),
                                            src: item.new_image_path
                                          }, null, 8, ["onClick", "src"])
                                        ]),
                                        _createVNode("td", _hoisted_63, [
                                          _createVNode("img", {
                                            onClick: ($event: any) => (_ctx.imgBtn(item.old_image_path)),
                                            style: {"max-width":"350px"},
                                            src: item.old_image_path
                                          }, null, 8, ["onClick", "src"])
                                        ]),
                                        _hoisted_64
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]),
                        _createVNode("div", _hoisted_65, [
                          _hoisted_66,
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dcData?.dc_change_detail_pgc, (k, v, i) => {
                            return (_openBlock(), _createBlock("div", { key: i }, [
                              _createVNode("p", _hoisted_67, _toDisplayString(i + 1) + "、" + _toDisplayString(v) + ":共" + _toDisplayString(k.count) + "个点有DC变化 ", 1),
                              (
                          _ctx.dcData?.dc_change_detail_pgc[v]?.dc_list?.length > 0
                        )
                                ? (_openBlock(), _createBlock("table", _hoisted_68, [
                                    _createVNode("thead", null, [
                                      _createVNode("tr", null, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pgc_detail, (item) => {
                                          return (_openBlock(), _createBlock("td", { key: item }, _toDisplayString(item), 1))
                                        }), 128))
                                      ])
                                    ]),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dcData?.dc_change_detail_pgc[v]
                            ?.dc_list, (item, i) => {
                                      return (_openBlock(), _createBlock("tr", { key: i }, [
                                        _createVNode("td", null, _toDisplayString(i + 1), 1),
                                        _createVNode("td", null, [
                                          _createVNode("div", null, _toDisplayString(item.key[2][1]), 1),
                                          _createVNode("div", null, _toDisplayString("(" +
                                item.key[0] +
                                "," +
                                item.key[1] +
                                "," +
                                item.key[2][0] +
                                ")"), 1)
                                        ]),
                                        _createVNode("td", null, [
                                          _createVNode("div", null, _toDisplayString(_ctx.diff(item.diff)), 1),
                                          _createVNode("div", null, "new:" + _toDisplayString(item.new), 1),
                                          _createVNode("div", null, "old:" + _toDisplayString(item.old), 1)
                                        ]),
                                        _createVNode("td", _hoisted_69, [
                                          _createVNode("img", {
                                            style: {"max-width":"350px"},
                                            onClick: ($event: any) => (_ctx.imgBtn(item.new_image_path)),
                                            src: item.new_image_path
                                          }, null, 8, ["onClick", "src"])
                                        ]),
                                        _createVNode("td", _hoisted_70, [
                                          _createVNode("img", {
                                            onClick: ($event: any) => (_ctx.imgBtn(item.old_image_path)),
                                            style: {"max-width":"350px"},
                                            src: item.old_image_path
                                          }, null, 8, ["onClick", "src"])
                                        ]),
                                        _hoisted_71
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createVNode("div", _hoisted_72, [
                        _hoisted_73,
                        _createVNode("div", _hoisted_74, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dcData?.full_dc, (k, v, i) => {
                            return (_openBlock(), _createBlock("div", {
                              key: i,
                              class: "spacName"
                            }, [
                              _createVNode("h6", _hoisted_75, [
                                _hoisted_76,
                                _createTextVNode(" " + _toDisplayString(v), 1)
                              ]),
                              _createVNode("table", _hoisted_77, [
                                _createVNode("thead", null, [
                                  _createVNode("tr", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.total_quantity, (item) => {
                                      return (_openBlock(), _createBlock("td", { key: item }, [
                                        _createVNode("div", null, _toDisplayString(item.value), 1),
                                        _createVNode("div", null, _toDisplayString(item.name), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(k, (item, i) => {
                                  return (_openBlock(), _createBlock("tr", { key: i }, [
                                    _createVNode("td", null, _toDisplayString(item.location), 1),
                                    _createVNode("td", null, _toDisplayString(item.direction), 1),
                                    _createVNode("td", null, _toDisplayString(item.old_dc), 1),
                                    _createVNode("td", null, _toDisplayString(item.dc), 1),
                                    _createVNode("td", null, _toDisplayString(item.diff_dc), 1),
                                    _createVNode("td", null, _toDisplayString(item.Tris), 1),
                                    _createVNode("td", null, _toDisplayString(item.Verts), 1),
                                    _createVNode("td", null, _toDisplayString(item.dynamicBatchedDC), 1),
                                    _createVNode("td", null, _toDisplayString(item.staticBatchedDC), 1),
                                    _createVNode("td", null, _toDisplayString(item.monoUsed), 1),
                                    _createVNode("td", null, _toDisplayString(item.monomem), 1)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ]),
                _withDirectives(_createVNode("div", {
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.maskBtn($event))),
                  class: "gallery__big"
                }, [
                  _createVNode("div", _hoisted_78, [
                    _createVNode("div", _hoisted_79, [
                      _createVNode("img", { src: _ctx.maskImg }, null, 8, ["src"])
                    ], 512)
                  ])
                ], 512), [
                  [_vShow, _ctx.showMask]
                ]),
                _hoisted_80
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})